<template>
  <div class="upload-files">
    <div style="display: flex; align-items: center; justify-content: center">
      <el-upload
        action="#"
        drag
        multiple
        :auto-upload="false"
        :accept="selectedFileType.accept"
        :on-change="handleChange"
        :show-file-list="false"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">
          Kéo thả {{ selectedFileType.label }} hoặc click để upload
        </div>
      </el-upload>
    </div>
    <div class="upload-files__list">
      <el-row :gutter="16">
        <el-col
v-for="file in fileList"
:key="file.uid"
:lg="6">
          <div class="file-card">
            <FileCard
              :file="file"
              :type="selectedFileType.key"
              :show-name="true"
            />
            <div
v-if="!disabled"
class="file-card__delete">
              <el-button
                circle
                size="mini"
                type="danger"
                @click="handleRemove(file)"
              >
                <i class="el-icon-close" />
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { fileToBase64 } from "@/utils/common";
import constants from "@/config/constants";
import FileCard from "../items/FileCard.vue";

export default {
  name: "UploadFiles",
  components: {
    FileCard,
  },
  props: {
    selectedFileType: Object,
    disabled: Boolean,
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
      fileList: [],
    };
  },
  methods: {
    async handleChange(file) {
      const fileUrl = await fileToBase64(file.raw);
      this.fileList.push({ ...file, url: fileUrl });
    },
    handleRemove(file) {
      if (file.uid) {
        this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      }
    },
  },
};
</script>

<style lang="scss">
.upload-files {
  &__list {
    margin-top: 24px;
    .file-card {
      border: 2px solid #409eff;
      padding: 4px;
      border-radius: 12px;
      position: relative;
      margin-bottom: 16px;
      .file-image,
      .file-other {
        width: 100%;
        border-radius: 12px;
        cursor: pointer;
      }
      .file-video {
        width: 100%;
        height: 100px;
        border-radius: 12px;
        cursor: pointer;
      }
      .file-audio {
        width: 100% !important;
      }
      &__delete {
        position: absolute;
        top: -12px;
        right: -12px;
      }
    }
  }
}
</style>
